"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IUserType = void 0;
var IUserType;
(function (IUserType) {
    IUserType["Premium"] = "premium";
    IUserType["Free"] = "free";
    IUserType["Anonymous"] = "anonymous";
})(IUserType || (exports.IUserType = IUserType = {}));
//# sourceMappingURL=user-type.js.map